import apiClient from './apiClient';

export const labelService = {
  getLabels: () => {
    return apiClient.get('/labels');
  },

  getLabel: (id) => {
    return apiClient.get(`/labels/${id}`);
  },

  createLabel: (data) => {
    return apiClient.post('/labels', data);
  },

  updateLabel: (id, data) => {
    return apiClient.put(`/labels/${id}`, data);
  },

  deleteLabel: (id) => {
    return apiClient.delete(`/labels/${id}`);
  },
};
